
import React, { useEffect, useState } from "react";
import confetti from "canvas-confetti";

export default function App() {
  const [name, setName] = useState("");
  const [savedName, setSavedName] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    const stored = localStorage.getItem("username");
    if (stored) setSavedName(stored);

    const timer = setInterval(() => {
      const now = new Date();
      const target = new Date("2026-01-01T00:00:00");
      const diff = target - now;

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);

      setTime(`${d} Days ${h} Hours ${m} Minutes ${s} Seconds`);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const submit = async () => {
    if (!name) return;
    localStorage.setItem("username", name);
    setSavedName(name);
    confetti({ particleCount: 150, spread: 120 });
    await fetch("/api/wish?name=" + name);
  };

  return (
    <div className="container">
      <h1>🎆 Advance New Year 2026 🎆</h1>
      <h2 className="countdown">{time}</h2>

      <input
        placeholder="Enter your name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <button onClick={submit}>Celebrate</button>

      {savedName && (
        <h2 className="greet">
          🎉 Advance New Year Wishes {savedName}! 🎉
        </h2>
      )}

      <p className="brand">Powered by DevopsForU</p>
    </div>
  );
}
